<template>
  <Modal
    ref="vettingModal"
    closed-by="none"
    full-width-content
    hide-close-button
    hide-confirm>
    <div class="flex flex-col items-center bg-white rounded-lg p-6 gap-6">
      <div class="relative flex justify-center w-full">
        <LanguageToggle
          direction="down"
          :languages="languages"
          @change-language="changeLanguage" />
      </div>

      <BaseImage
        :alt="t('vetting.illustrationAlt')"
        class="max-w-[122px]"
        src="/staticv2/images/vetting-illustration.png" />

      <div class="text-center">
        <Heading level="2">
          {{ t('vetting.title') }}
        </Heading>
        <Paragraph class="text-gray-800 text-sm mt-1">
          {{ t('vetting.subtitle') }}
        </Paragraph>
      </div>

      <VettingForm @success="onSuccess" />
    </div>
  </Modal>
</template>

<script setup lang="ts">
import type {ModalExposedValues} from '@myparcel-frontend/ui';
import {useProposition} from '@myparcel-frontend/proposition';
import {Heading, LanguageToggle, Modal, Paragraph, BaseImage} from '@myparcel-frontend/ui';
import {language} from '@myparcel-frontend/utils';
import {computed, onMounted, useTemplateRef} from 'vue';
import {useI18n} from 'vue-i18n';
import VettingForm from './VettingForm.vue';
import useChangeLanguage from '../../../composables/useChangeLanguage/useChangeLanguage';

const {t, locale} = useI18n();
const modalElement = useTemplateRef<ModalExposedValues>('vettingModal');
const {proposition} = useProposition();
const {changeLanguage} = useChangeLanguage();

const languages = computed(() =>
  language.formatLanguageOptions(
    proposition.value.applications.backoffice.internationalization.supportedLanguages,
    locale.value,
  ),
);

const onSuccess = (): void => {
  modalElement.value?.cancel();
};

/* istanbul ignore next */
/**
 * Re-expose modal methods to parent components
 */
defineExpose({
  show: () => {
    modalElement.value?.show();
  },
  cancel: () => {
    modalElement.value?.cancel();
  },
  confirm: () => {
    modalElement.value?.confirm();
  },
});

onMounted(() => {
  modalElement.value?.show();
});
</script>
